'use strict';

var templates = require('../templates');
var fobclient = require('..');
var AppRole = require('../entity').AppRole;

module.exports = function (connection) {
  return {
    byNameEquals: function byNameEquals(name, additionalParams) {
      return templates.searchTemplate(connection)(AppRole, 'byNameEquals', 'name')(name, additionalParams);
    },
    byNameLike: function byNameLike(name, additionalParams) {
      return templates.searchTemplate(connection)(AppRole, 'byNameLike', 'name')(name, additionalParams);
    },
    bySearchRepLike: function bySearchRepLike(rep, additionalParams) {
      return templates.searchTemplate(connection)(AppRole, 'bySearchRepLike', 'rep')(rep, additionalParams);
    },
    withGenericAnd: function withGenericAnd(searchParams) {
      return templates.genericSearchTemplate(connection)(AppRole, 'genericand')(searchParams);
    },
    byID: function byID(_id) {
      return fobclient.genericGet('approle')(_id);
    }
  };
};


//////////////////
// WEBPACK FOOTER
// ./~/fobclient/lib/find/appRole.js
// module id = pkja
// module chunks = 0